import { useMemo } from 'react';

import {
  DEFAULT_UTM_PARAMS,
  getUtmCookieClient,
  geUrlParams,
} from 'lib/cookies/utm-cookie';

export type UtmParamsOptional = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_referrer?: string;
};

// utm inheritance order
// cookie utm -> prop utm -> default utm

const isSameOrigin = (a: string, b: string): boolean => {
  const urlA = new URL(a);
  const urlB = new URL(b);
  return urlA.origin === urlB.origin;
};

export function useCurrentUtm(
  customUtm?: UtmParamsOptional,
): UtmParamsOptional {
  if (typeof window === 'undefined') {
    return {};
  }

  const utmCookie = getUtmCookieClient();

  return useMemo(() => {
    const utm_referrer =
      document.referrer &&
      isSameOrigin(document.referrer, window.location.origin)
        ? { utm_referrer: document.referrer }
        : {};

    return {
      ...DEFAULT_UTM_PARAMS,
      ...utm_referrer,
      ...customUtm,
      ...utmCookie,
    };
  }, [customUtm, utmCookie]);
}

export function getAppUtm(): boolean {
  if (typeof window !== 'undefined') {
    const params = geUrlParams(new URL(window?.location.href).searchParams);

    if (params?.utm_source === 'app') {
      return true;
    }
  }
  return false;
}
